import axiosInstance from "../../../common/axios/axsiosInstance";
export function getAccessToken() {
  const data = localStorage.getItem("accessToken");
  const response = data;
  return response;
}
const token = getAccessToken();

export async function getFileUrn() {
  try {
    const response = await axiosInstance.get(`user/my-urns`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to get translation status: ${errorMessage}`);
  }
}

export async function getUrnStatus(id) {
  const response = await axiosInstance.get(`user/my-urns/${id}/status`);
  return response.data;
}

export async function downloadFile(id) {
  try {
    const response = await axiosInstance.get(`/forge/download/${id}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to download file: ${errorMessage}`);
  }
}
export async function deleteFileUrn() {
  try {
    const response = await axiosInstance.delete(`user/my-urns`);

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to get translation status: ${errorMessage}`);
  }
}
export async function deleteFileUrnId(id) {
  try {
    const response = await axiosInstance.delete(`user/my-urns/${id}`);

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(`Failed to get translation status: ${errorMessage}`);
  }
}
